import { useMe } from '../api/hooks';

/** Ce que la personne connectée peut voir et faire (selon ses rôles Keycloak) */
export function useAccess() {
  const me = useMe();
  const libs = me.data?.libraries ?? [];
  return {
    me: me.data,
    libraries: libs,
    hasMusic: libs.some((l) => l.kind === 'music'),
    hasStories: libs.some((l) => l.kind === 'stories'),
    canUpload: !!me.data?.canUpload,
    isAdmin: !!me.data?.isAdmin,
  };
}
